import React, { useEffect, useState } from 'react';
import ApiServices from '../../Utils/ApiServices/ApiServices';
import { useParams } from 'react-router-dom';
import {
  getDecryptedAccessToken,
  getDecryptedData,
  getDecryptedUserType,
} from '../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import {
  Typography,
  CircularProgress,
  Alert,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Snackbar,
  Alert as MuiAlert,
} from '@mui/material';
import dayjs from 'dayjs';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AppointmentCardPaymentBill from '../ProviderComponents/AppointmentDetails/BillingData/AppointmentCardPaymentBill';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const GenerateMembershipBill = ({ members,onPaymentSuccess  }) => {
  const { plan_id, groupId } = useParams();
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PROMISE);
  
  const accessToken = getDecryptedAccessToken();
  const LoginUserType = getDecryptedUserType();
  const LoginUserDetails = getDecryptedData();
  const [priceTiers, setPriceTiers] = useState([]);
  const [validityMonths, setValidityMonths] = useState(null);
  const [calculatedMembers, setCalculatedMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [openDialog, setOpenDialog] = useState(false);
  console.log("LoginUserType",LoginUserType)
  console.log("LoginUserDetails",LoginUserDetails)

  useEffect(() => {
    const fetchMembershipPlan = async () => {
      if (!plan_id) return;

      const apiUrl =
        LoginUserType === 'Patient'
          ? `/apis/default/portal/membershipplan/${plan_id}`
          : `/apis/default/api/membershipplan/${plan_id}`;

      try {
        const res = await ApiServices.get(apiUrl, {
          Authorization: `Bearer ${accessToken}`,
        });

        if (res.data && Array.isArray(res.data.age_based_pricing)) {
          setPriceTiers(res.data.age_based_pricing);
          setValidityMonths(res.data.validity_months || 12);
        } else {
          setApiError('Invalid response format for pricing data.');
        }
      } catch (error) {
        console.error('Error fetching membership plan:', error);
        setApiError('Failed to fetch membership plan. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchMembershipPlan();
  }, [plan_id, accessToken, LoginUserType]);

  useEffect(() => {
    if (!priceTiers.length) return;

    const getPriceForAge = (age) => {
      for (let tier of priceTiers) {
        if (age >= Number(tier.min_age) && age < Number(tier.max_age)) {
          return Number(tier.price);
        }
      }
      return 0;
    };

    const inactiveMembers = members.filter((member) => member.active === 0);
    const sortedMembers = [...inactiveMembers];

    const calculated = sortedMembers.map((member, index) => {
      const basePrice = getPriceForAge(Number(member.age));
      let discount = 0;

      if (index === 1) discount = 0.1;
      else if (index === 2) discount = 0.2;
      else if (index >= 3) discount = 0.3;

      const finalPrice = basePrice - basePrice * discount;

      return {
        ...member,
        basePrice,
        discountPercent: discount * 100,
        finalPrice,
      };
    });

    setCalculatedMembers(calculated);
  }, [priceTiers, members]);

  const totalPrice = calculatedMembers.reduce((sum, m) => sum + m.finalPrice, 0);
  // const adminMember = members.find((m) => m.role === 'admin');
  const adminMember =
  members.some((m) => m.role === 'admin' && m.pid === LoginUserDetails.pid) ||
  LoginUserType != 'Patient';
const handleOpenDialog = () => {
  setOpenDialog(true);
};
const handleCloseDialog = () => {
  setOpenDialog(false);
};


const handlePayment = async () => {
  const startDate = dayjs();
  const endDate = startDate.add(validityMonths || 12, 'month');

  const payload = {
    members: calculatedMembers.map((member) => ({
      pid: member.pid,
      price_applied: member.basePrice,              
      discount_applied: member.discountPercent,     
      final_price: member.finalPrice.toFixed(2),    
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
      active:1
    })),
  };

  const apiUrl =
    LoginUserType === 'Patient'
      ? `/apis/default/portal/membershipgroups/${groupId}/billingweb`
      : `/apis/default/api/membershipgroups/${groupId}/billingweb`;

  try {
    const res = await ApiServices.post(apiUrl, payload, {
      Authorization: `Bearer ${accessToken}`,
    });

    if (res.data?.status === 'success') {
      setSnackbar({ open: true, message: 'Payment successful.', severity: 'success' });
       if (typeof onPaymentSuccess === 'function') {
    onPaymentSuccess();
  }
    } else {
      throw new Error(res.data?.message || 'Payment failed.');
    }
  } catch (error) {
    console.error('Payment Error:', error);
    setSnackbar({ open: true, message: error.message || 'Payment failed.', severity: 'error' });
  }
};


  return (
    <div style={{marginTop:"20px"}}>
      <Typography variant="h5" gutterBottom>
        Membership Bill Invoice
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : apiError ? (
        <Alert severity="error">{apiError}</Alert>
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Member Name</TableCell>
                  <TableCell>Age</TableCell>
                  <TableCell>Base Price ($)</TableCell>
                  <TableCell>Discount (%)</TableCell>
                  <TableCell>Final Price ($)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {calculatedMembers.map((member, index) => (
                  <TableRow key={member.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{member.fname} {member.lname}</TableCell>
                    <TableCell>{member.age}</TableCell>
                    <TableCell>{member.basePrice.toFixed(2)}</TableCell>
                    <TableCell>{member.discountPercent}</TableCell>
                    <TableCell>{member.finalPrice.toFixed(2)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Divider sx={{ my: 2 }} />
          <Typography variant="h6">
            Total Price: ${totalPrice.toFixed(2)}
          </Typography>
{adminMember &&
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenDialog}
            sx={{ mt: 2 }}
            disabled={calculatedMembers.length === 0}
          >
            Pay Now
          </Button>}
        </>
      )}

      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
  <DialogTitle>
    Payment Details
    <IconButton
      aria-label="close"
      onClick={handleCloseDialog}
      sx={{ position: 'absolute', right: 8, top: 8 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
  <DialogContent dividers>
    {adminMember ? (
       <Elements stripe={stripePromise}>
                  <AppointmentCardPaymentBill
                     patientData={adminMember}
        amount={totalPrice.toFixed(2)}
        onSuccess={() => {
          handlePayment();
          handleCloseDialog();
        }}
                  />
                </Elements>
    ) : (
      <Alert severity="error">Admin user not found for payment processing.</Alert>
    )}
  </DialogContent>
</Dialog>


      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default GenerateMembershipBill;
